import { Box, CTALink, Heading } from '@99designs/emu';
import { GridLayout, ProductCardGroup, ProductCardProps } from '@99designs/marketing-ui';
import { trackCTAClicked } from '../../../lib/events';
import { ProductLandingGroupKey } from '../../../lib/productLandingGroups';

type RelatedProductsSectionProps = {
    ctaLink: string;
    products: ProductCardProps[];
    categoryKey: ProductLandingGroupKey;
};

export const RelatedProductsSection = ({
    ctaLink,
    products,
    categoryKey,
}: RelatedProductsSectionProps) => {
    const tileTracking = (product: ProductCardProps) => ({
        event: 'Product Tile Clicked',
        meta: {
            category: categoryKey,
            productName: product.title,
        },
    });

    function SeeAllCta() {
        return (
            <CTALink
                href={ctaLink}
                onClick={() =>
                    trackCTAClicked({
                        category: categoryKey,
                        ctaLocation: 'related-products',
                        ctaButton: 'See all design services',
                    })
                }
            >
                {__('See all design services')}
            </CTALink>
        );
    }

    return (
        <Box paddingY={['3bu', '3bu', '4bu', '6bu']}>
            <GridLayout>
                <Box display="flex" justifyContent={'space-between'}>
                    <Heading accessibilityLevel={2} appearanceLevel={3}>
                        {__('Explore our logo & identity packages')}
                    </Heading>
                    <Box display={['none', 'none', 'block', 'block']} alignSelf={'end'}>
                        <SeeAllCta />
                    </Box>
                </Box>
            </GridLayout>
            <ProductCardGroup products={products} tracking={tileTracking} />
            <Box display={['flex', 'flex', 'none', 'none']} justifyContent="center">
                <SeeAllCta />
            </Box>
        </Box>
    );
};
